import { useEffect, useState } from 'react';
import menuStore from '../../utils/localForageInstance';
import EditModalOld from './EditModalOld';
import EditModalNew from './EditModalNew';

// Dispatches to the legacy per-size ingredient editor or the grouped-ingredient
// editor based on productData.new_product_config (set by the backend as
// RestaurantConfig::isProductConfigurationEnabled() && product->getIsNewProductConfigEnabled()).
const EditModal = (props) => {
    const { item, isOpen } = props;
    const [isGroupedConfig, setIsGroupedConfig] = useState(null);

    useEffect(() => {
        const checkConfig = async () => {
            if (!item?.item_id) return;
            const data = await menuStore.getItem(`product_${item.item_id}`);
            // data.new_product_config is already restaurant-flag AND product-flag combined
            // (DishService.php:814) - no separate restaurant-only field to check here.
            console.log('EditModal: checkConfig', item.item_id, data?.new_product_config);
            setIsGroupedConfig(!!data?.new_product_config);
        };

        if (isOpen) {
            checkConfig();
        } else {
            setIsGroupedConfig(null);
        }
    }, [item, isOpen]);

    if (!isOpen || isGroupedConfig === null) return null;

    return isGroupedConfig ? <EditModalNew {...props} /> : <EditModalOld {...props} />;
};

export default EditModal;
